import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  margin-left: -3px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  svg {
    margin-right: 5px;
    color: #0384ac;
    font-size: 24px;
  }
`;

export const Button = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.p`
  ${(props) =>
    props.bold &&
    `
    font-weight: bold;
  `}
  font-size: 14px;
  color: #0384ac;
`;
